/* RESPONSIBLE TEAM: team-inbox-experience */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/-private/transition';
import type NewConversationController from 'embercom/controllers/inbox/workspace/inbox/new-conversation';
import type AppService from 'embercom/services/app-service';
import type Session from 'embercom/services/session';
import type InboxState from 'embercom/services/inbox-state';

interface PermissionsService {
  ensurePermissionWhenTransitioning(
    permission: string,
    transition: Transition,
    failureRoute: string,
  ): Promise<void>;
}

export default class extends Route {
  @service declare appService: AppService;
  @service declare permissionsService: PermissionsService;
  @service declare session: Session;
  @service declare inboxState: InboxState;

  queryParams = { recipient: {}, ticketTypeId: {}, forwardedPartId: {} };

  async beforeModel(transition: Transition) {
    if (!this.session.teammate.permissions.canManageConversationCreation) {
      if (!this.appService.app) {
        await this.appService.loadApp(this.session.workspace.id);
      }
      await this.permissionsService.ensurePermissionWhenTransitioning(
        'can_manage_conversation_creation',
        transition,
        'inbox.workspace.inbox',
      );
    }
  }

  reactEnabled(): boolean {
    // Toggle-aware so the route metadata (isReactRoute) agrees with the template's
    // `state.showReactNewConversation` switch. Guard on workspace load before the
    // getter touches `session.workspace`.
    return this.session.isWorkspaceLoaded && this.inboxState.showReactNewConversation;
  }

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-inbox',
      react: this.reactEnabled(),
    };
  }

  resetController(controller: NewConversationController, isExiting: boolean) {
    if (isExiting) {
      controller.recipient = undefined;
      controller.ticketTypeId = undefined;
      controller.forwardedPartId = undefined;
    }
  }
}
